import * as ids from './dispossitions.const';

/**
 * Mediation
 */
export const CR_ME_OPEN_PENDING = {
    _id: ids.CR_ME_OPEN_PENDING_ID,
    label: 'Open/Pending',
    closed: false,
    description: 'In process',
    errorMessage: '',
};

export const CR_ME_FULL_AGREEMENT = {
    _id: ids.CR_ME_FULL_AGREEMENT_ID,
    label: 'Full Agreement',
    closed: true,
    description: 'Parties participated in one or more sessions and reached full agreement',
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};

export const CR_ME_NO_AGREEMENT = {
    _id: ids.CR_ME_NO_AGREEMENT_ID,
    label: 'No Agreement',
    closed: true,
    description: 'Parties participated in one or more sessions and did not reach agreement',
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};

export const CR_ME_PARTIAL_AGREEMENT = {
    _id: ids.CR_ME_PARTIAL_AGREEMENT_ID,
    label: 'Partial Agreement',
    closed: true,
    description: 'Parties participated in one or more sessions and reached partial agreement',
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};

export const CR_ME_NO_CONTACT = {
    _id: ids.CR_ME_NO_CONTACT_ID,
    label: 'No Contact',
    description: 'CMC is unable to make contact with any party despite multiple attempts',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any intake or mediation action.',
};

export const CR_ME_TOO_FEW_PARTIES = {
    _id: ids.CR_ME_TOO_FEW_PARTIES_ID,
    label: 'Too Few Parties',
    description:
        'Not enough parties to proceed to mediation e.g: party(ies) declined; contact with only one party; etc.',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any mediation actions..',
};

export const CR_ME_CANCELED_NO_SHOW = {
    _id: ids.CR_ME_CANCELED_NO_SHOW_ID,
    label: 'Canceled/No Show',
    description: 'Party(ies) canceled or did not show up for the first session',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending mediation action. You need at least one canceled mediation actions.',
};

export const CR_ME_DECLINED = {
    _id: ids.CR_ME_DECLINED_ID,
    label: 'Declined - At Mediation',
    description: "Party(ies) declined after Mediators' Introduction at first session",
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};
export const CR_ME_WITHDRAWN = {
    _id: ids.CR_ME_WITHDRAWN_ID,
    label: 'Withdrawn',
    description: 'Party(ies) withdrew after participating in at least one session',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};

export const CR_ME_DISCONTINUED = {
    _id: ids.CR_ME_DISCONTINUED_ID,
    label: 'Discontinued',
    description: 'CMC discontinued services after at least one session e.g. party(ies) became unresponsive, etc.',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed mediation action to select this disposition.',
};

export const CR_ME_INAPPROPRIATE = {
    _id: ids.CR_ME_INAPPROPRIATE_ID,
    label: 'Inappropriate',
    description: 'CMC determined case is not appropriate for mediation',
    closed: true,
    errorMessage: '',
};

export const CR_ME_LIMITED_RESOURCES_MEDIATOR = {
    _id: ids.CR_ME_LIMITED_RESOURCES_MEDIATOR_ID,
    label: 'Limited Resource(s) - Mediator',
    description: 'No mediator(s) available to mediate',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any mediation actions',
};

export const CR_ME_LIMITED_RESOURCES_INTERPRETER = {
    _id: ids.CR_ME_LIMITED_RESOURCES_INTERPRETER_ID,
    label: 'Limited Resource(s) - Interpreter',
    description: 'No interpreter(s) available to interpret',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending mediation action. You can have one or more cancelled mediation actions.',
};

export const CR_ME_LIMITED_RESOURCES_TECHNOLOGY = {
    _id: ids.CR_ME_LIMITED_RESOURCES_TECHNOLOGY_ID,
    label: 'Limited Resource(s) - Technology',
    description: 'CMC or party(ies) cannot participate due to insufficient access to technology',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending mediation action. You can have one or more cancelled mediation actions.',
};

export const CR_ME_LIMITED_RESOURCES_SPACE = {
    _id: ids.CR_ME_LIMITED_RESOURCES_SPACE_ID,
    label: 'Limited Resource(s) - Space',
    description: 'No suitable physical space is available to hold the mediation',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any mediation actions.',
};

export const CR_ME_LIMITED_RESOURCES_OTHER = {
    _id: ids.CR_ME_LIMITED_RESOURCES_OTHER_ID,
    label: 'Limited Resource(s) - Other',
    description: 'Lack of other resources not already listed',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any mediation actions.',
};

/***
 * Conciliation
 */
export const CR_CO_OPEN_PENDING = {
    _id: ids.CR_CO_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const CR_CO_FULL_AGREEMENT = {
    _id: ids.CR_CO_FULL_AGREEMENT_ID,
    label: 'Full Agreement',
    description: 'Parties participated in one or more sessions and reached full agreement',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};

export const CR_CO_NO_AGREEMENT = {
    _id: ids.CR_CO_NO_AGREEMENT_ID,
    label: 'No Agreement',
    description: 'Parties participated in one or more sessions and did not reach agreement',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};
export const CR_CO_PARTIAL_AGREEMENT = {
    _id: ids.CR_CO_PARTIAL_AGREEMENT_ID,
    label: 'Partial Agreement',
    description: 'Parties participated in one or more sessions and reached partial agreement',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};
export const CR_CO_NO_CONTACT = {
    _id: ids.CR_CO_NO_CONTACT_ID,
    label: 'No Contact',
    description: 'CMC is unable to make contact with party(ies) despite multiple attempts',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any intake or conciliation action.',
};
export const CR_CO_TOO_FEW_PARTIES = {
    _id: ids.CR_CO_TOO_FEW_PARTIES_ID,
    label: 'Too Few Parties',
    description:
        'Not enough parties to proceed to conciliation e.g: party(ies) declined; contact with only one party; scheduled conciliation canceled; etc.',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any conciliation actions.',
};
export const CR_CO_CANCELLED_NO_SHOW = {
    _id: ids.CR_CO_CANCELLED_NO_SHOW_ID,
    label: 'Canceled/No Show',
    description: 'Party(ies) did not show up for the first scheduled session',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending mediation action. You need at least one canceled mediation actions.',
};
export const CR_CO_DECLINED = {
    _id: ids.CR_CO_DECLINED_ID,
    label: 'Declined - At Conciliation',
    description: "Party(ies) declined after Conciliators' Introduction at first session",
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};
export const CR_CO_WITHDRAWN = {
    _id: ids.CR_CO_WITHDRAWN_ID,
    label: 'Withdrawn',
    description: 'Party(ies) withdrew after participating in at least one session',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};

export const CR_CO_DISCONTINUED = {
    _id: ids.CR_CO_DISCONTINUED_ID,
    label: 'Discontinued',
    description: 'CMC discontinued services after at least one session e.g. party(ies) became unresponsive, etc.',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed conciliation action to select this disposition.',
};
export const CR_CO_INAPPROPRIATE = {
    _id: ids.CR_CO_INAPPROPRIATE_ID,
    label: 'Inappropriate',
    description: 'CMC determined case is not appropriate for conciliation',
    closed: true,
    errorMessage: '',
};
export const CR_CO_LIMITED_RESOURCES_CONCILATOR = {
    _id: ids.CR_CO_LIMITED_RESOURCES_CONCILATOR_ID,
    label: 'Limited Resource(s) - Conciliator',
    description: 'No conciliator(s) available to conciliate',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any conciliation actions.',
};

export const CR_CO_LIMITED_RESOURCES_INTERPRETER = {
    _id: ids.CR_CO_LIMITED_RESOURCES_INTERPRETER_ID,
    label: 'Limited Resource(s) - Interpreter',
    description: 'No interpreter(s) available to interpret',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending conciliation action. You can have one or more cancelled conciliation actions.',
};
export const CR_CO_LIMITED_RESOURCES_TECHNOLOGY = {
    _id: ids.CR_CO_LIMITED_RESOURCES_TECHNOLOGY_ID,
    label: 'Limited Resource(s) - Technology',
    description: 'CMC or party(ies) cannot participate due to insufficient access to technology',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending conciliation action. You can have one or more cancelled conciliation actions.',
};

export const CR_CO_LIMITED_RESOURCES_SPACE = {
    _id: ids.CR_CO_LIMITED_RESOURCES_SPACE_ID,
    label: 'Limited Resource(s) - Space',
    description: 'No suitable physical space is available to hold the conciliation',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any conciliation actions.',
};

export const CR_CO_LIMITED_RESOURCES_OTHER = {
    _id: ids.CR_CO_LIMITED_RESOURCES_OTHER_ID,
    label: 'Limited Resource(s) - Other',
    description: 'Lack of other resources not already listed',
    closed: true,
    errorMessage: 'Invalid choice. To select this disposition, you cannot have any conciliation actions.',
};

/**
 * Facilitation
 */
export const CR_FA_OPEN_PENDING = {
    _id: ids.CR_FA_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const CR_FA_COMPLETED = {
    _id: ids.CR_FA_COMPLETED_ID,
    label: 'Completed',
    description: 'Parties completed the facilitation process',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed facilitation action to select this disposition.',
};

export const CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION = {
    _id: ids.CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION_ID,
    label: 'Withdrawn/Discontinued - Before a facilitation session',
    description: 'Party(ies) withdrew/declined before any facilitation session',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending facilitation action. You can have one or more cancelled facilitation actions.',
};

export const CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION = {
    _id: ids.CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION_ID,
    label: 'Withdrawn/Discontinued - After one or more facilitation sessions',
    description: 'Party(ies) withdrew after participating in at least one facilitation session',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed facilitation action to select this disposition.',
};

/**
 * Conflict Coaching
 */

export const CR_CC_OPEN_PENDING = {
    _id: ids.CR_CC_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const CR_CC_COMPLETED = {
    _id: ids.CR_CC_COMPLETED_ID,
    label: 'Completed',
    description: 'Party completed Conflict Coaching process',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed conflict coaching action to select this disposition.',
};

export const CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION = {
    _id: ids.CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION_ID,
    label: 'Withdrawn - Before a conflict coaching session',
    description: 'Party withdrew before a Conflict Coaching session',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending conflict coaching action. You can have one or more cancelled conflict coaching actions.',
};

export const CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION = {
    _id: ids.CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION_ID,
    label: 'Withdrawn - After one or more conflict coaching sessions',
    description: 'Party withdrew after one or more Conflict Coaching sessions',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed conflict coaching action to select this disposition.',
};

export const CR_CC_INAPPROPRIATE = {
    _id: ids.CR_CC_INAPPROPRIATE_ID,
    label: 'Inappropriate',
    description: 'CMC determined case to be not appropriate for Conflict Coaching',
    closed: true,
    errorMessage: '',
};

export const CR_RPC_OPEN_PENDING = {
    _id: ids.CR_RPC_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const CR_RPC_COMPLETED = {
    _id: ids.CR_RPC_COMPLETED_ID,
    label: 'Completed',
    description: 'Party(ies) completed RJ process',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed restorative circle action to select this disposition.',
};

export const CR_RPC_AGREEMENT = {
    _id: ids.CR_RPC_AGREEMENT_ID,
    label: 'Agreement',
    description: 'Parties participated in one or more sessions and reached full agreement',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed restorative circle action to select this disposition.',
};

export const CR_RPC_NO_AGREEMENT = {
    _id: ids.CR_RPC_NO_AGREEMENT_ID,
    label: 'No Agreement',
    description: 'Parties participated in one or more sessions and did not reach agreement',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed restorative circle action to select this disposition.',
};

export const CR_RPC_PARTIAL_AGREEMENT = {
    _id: ids.CR_RPC_PARTIAL_AGREEMENT_ID,
    label: 'Partial Agreement',
    description: 'Parties participated in one or more sessions and reached partial agreement',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed restorative circle action to select this disposition.',
};

export const CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE = {
    _id: ids.CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE_ID,
    label: 'Withdrawn - Before a restorative circle',
    description: 'Party(ies) withdrew/declined before any RJ session',
    closed: true,
    errorMessage: 'Invalid choice. You cannot have a completed restorative circle action to select this disposition.',
};

export const CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE = {
    _id: ids.CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE_ID,
    label: 'Withdrawn - After one or more restorative circle',
    description: 'Party(ies) withdrew after participating in at least one RJ session',
    closed: true,
    errorMessage:
        'Invalid choice. You need at least one completed restorative circle action to select this disposition.',
};

export const CR_DD_OPEN_PENDING = {
    _id: ids.CR_DD_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const CR_DD_COMPLETED = {
    _id: ids.CR_DD_COMPLETED_ID,
    label: 'Completed',
    description: 'Party(ies) completed the Deliberative Dialogue process',
    closed: true,
    errorMessage: 'Invalid choice. You need one completed Deliberative Dialogue action to select this disposition.',
};

export const CR_DD_WITHDRAWN = {
    _id: ids.CR_DD_WITHDRAWN_ID,
    label: 'Withdrawn - Before a Deliberative Dialogue session',
    description: 'Party(ies) withdrew before the Deliberative Dialogue session',
    closed: true,
    errorMessage:
        'Invalid choice. To select this disposition, you cannot have a completed or pending Deliberative Dialogue action. You can have one or more cancelled Deliberative Dialogue actions.',
};

export const CR_OTH_OPEN_PENDING = {
    _id: ids.CR_OTH_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const CR_OTH_COMPLETED = {
    _id: ids.CR_OTH_COMPLETED_ID,
    label: 'Completed',
    description: 'Party(ies) completed other conflict resolution process',
    closed: true,
    errorMessage: '',
};

export const CR_OTH_WITHDRAWN = {
    _id: ids.CR_OTH_WITHDRAWN_ID,
    label: 'Withdrawn',
    description: 'Party(ies) withdrew before other conflict resolution session',
    closed: true,
    errorMessage: '',
};
